<template>
  <div class="container">
    <div class="top_img">
        <img src="../../assets/img/jft_red_tit.png" alt="">
    </div>
    <div class="inputGrpup">
      <div class="bgWhite">
        <van-cell-group>
          <van-field
            class="lister phone"
            type="tel"
            v-model="form.phone"
            @keydown.native="keyDown($event)"
            maxlength="11"
            @input="
              (value) => {
                form.phone = value.replace(/[^\d]+/g, '');
              }
            "
            placeholder="请输入手机号"
          />
          <van-field
            class="lister psw"
            :type="seePsw ? 'password' : 'text'"
            @input="
              (value) => {
                form.password = value.replace(/[^\w_]/g, '');
              }
            "
            v-model="form.password"
            placeholder="请设置8~16位数字+字母组合密码"
          >
            <template #button>
              <div @click="handSeePsw">
                <img
                  src="../../assets/img/bieyes.png"
                  style="width: 15px"
                  v-show="seePsw == true"
                />
                <img
                  src="../../assets/img/eyes.png"
                  style="width: 15px"
                  class="see"
                  v-show="seePsw == false"
                />
              </div>
            </template>
          </van-field>
          <van-field
            class="lister code2"
            v-model="form.verifyCode"
            maxlength="6"
            @input="
              (value) => {
                form.verifyCode = value.replace(/[^\d]+/g, '');
              }
            "
            placeholder="请输入验证码"
          >
            <template #button>
              <div class="code">
                <div class="codeGroup">
                  <div>|</div>
                  <div class="subCondeGrpup">
                    <span
                      @click="start"
                      class="codeTxt"
                      v-show="timeStatus == '0001'"
                      >获取验证码</span
                    >
                    <div v-show="timeStatus == '0000'" class="sub">
                      <van-count-down
                        ref="countDown"
                        millisecond
                        :time="time"
                        :auto-start="false"
                        format="ss"
                        @finish="finish"
                      />&nbsp;&nbsp;&nbsp; 秒后重试
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </van-field>
        </van-cell-group>
        <div class="bottom-button">
          <van-button
            color="#FF1A00"
            block
            @click="submit"
            class="btn"
            :loading="loading"
          >
            立即注册
          </van-button>
          <div class="info">
            <div class="info_img" @click="doSelect" v-show="selectAgreement==false"><img src="../../assets/img/dx_red.png" alt=""></div>
            <div class="info_img" @click="doSelect" v-show="selectAgreement==true"><img src="../../assets/img/select_red.png" alt=""></div>
            我已阅读并同意
            <span class="agreement" @click="handServeAgreementsUrl">《用户服务协议》</span>
            <span>和</span>
            <span class="agreement" @click="handPrivateAgreementUrl">
              《隐私政策》
            </span>
          </div>
        </div>
      </div>
    </div>
    <!--红包弹窗-->
    <div class="red_cont" v-show="isShow">
      <div v-show="isShowone">
        <img src="../../assets/img/red_con.png" alt="">
        <div class="red_but">
          <img src="../../assets/img/red_but.png" alt="">
        </div>
      </div>
      <div v-show="isShowtwo">
        <img src="../../assets/img/red_con2.png" alt="">
        <div class="red_con_number">
          <h1>{{rewardAmt}}元</h1>
          <p>{{redmessage}}</p>
        </div>
        <div class="red_but2" @click="handDlownload">打开APP提现</div>
      </div>
    </div>
    <div class="red_back" v-show="isShow"></div>
  </div>
</template>

<script>
import Vue from "vue";
import { isPoneAvailable } from "@/assets/js/common";
import { Field } from "vant";
import { Button } from "vant";
import { CellGroup } from "vant";
import { Toast, CountDown, Form } from "vant";

import { shareUrl, baseUrl } from "@/assets/js/api";

Vue.use(Field);
Vue.use(Button);
Vue.use(CellGroup);
Vue.use(Toast);
Vue.use(CountDown);
Vue.use(Form);
export default {
  data() {
    return {
      isDisabled: "0000",
      time: 60000,
      timeStatus: "0001", //0001的话显示倒计时  0000显示倒计时
      value: "",
      seePsw: true,
      selectAgreement:false,
      url: "https://spapps-api.hkrt.cn/app-api", //公共地址
      // 需要提交的数据
      form: {
        phone: "", //手机号码
        password: "", //密码
        verifyCode: "", //验证码
        commendCode: "", //推荐码
        appTag: 0, //类型 appTag  0 佳付通  1 富裕钱包
      },
      loading:false,
      isShow:false,
      officeUid:'',//获取红包金额使用
      rewardAmt:'',//红包金额
      redmessage:'',//红包文案
      isShowone:false,
      isShowtwo:false,
    };
  },
  created() {
    document.title = "注册领取红包";
    let commendCode = this.$route.query.commendCode;
    if(!!commendCode){
      this.form.commendCode = commendCode;
    }
    //判断是否回显上次输入的值
    if(this.$route.query.isBack && this.$route.query.isBack=='0000'){
      this.getInfos();
    }
  },
  methods: {
    // 获取信息
    getInfos(){
      let { phone,password } = this.$store.state.shareInfos
      this.form.password = password;
      this.form.phone = phone;
    },

    // 存储到vuex
    vuexStorage(){
      this.$store.commit("setShareInfo",this.form)
    },


    keyDown(e) {
      if (e.keyCode == 32) {
        e.returnValue = false;
      }
    },
    handSeePsw() {
      this.seePsw = !this.seePsw;
    },
    //隐私政策
    handPrivateAgreementUrl() {
      this.vuexStorage()
      this.$router.push({
        name: "jftPrivateAgreement",
        query:{
          entryMode:'backs',
          commendCode:this.$route.query.commendCode,
          activeCode:this.$route.query.activeCode
        }
      });
    },
    //用户服务协议
    handServeAgreementsUrl() {
      this.vuexStorage()
      this.$router.push({
        name: "jftAerveAgreement",
        query:{
          entryMode:'backs',
          commendCode:this.$route.query.commendCode,
          activeCode:this.$route.query.activeCode
        }
      });
    },
    handDlownload() {
      this.$router.push({
        name: "downloadforjft",
      });
    },
    //选中协议
    doSelect(){
        if(this.selectAgreement == false){
            this.selectAgreement = true
        }else{
            this.selectAgreement = false
        }
    },
    start() {
      if (this.form.phone == "") {
        Toast("手机号不能为空");
        return false;
      }

      if (isPoneAvailable(this.form.phone) == false) {
        Toast("手机号输入有误");
        return false;
      }
      // 0001代表不让点击

      if (this.isDisabled == "0001") {
        console.log("不让点击");
        return false;
      }
      this.isDisabled = "0001";
      let obj = {
        phone: this.form.phone,
        commendCode: this.form.commendCode,
        appTag:this.form.appTag
      };
      baseUrl("/message/v1/webSend", obj)
        .then((res) => {
          this.isDisabled = "0000";
          if (res.data.code == "0000") {
            this.timeStatus = "0000";
            this.$refs.countDown.start();
          } else {
            Toast(res.data.msg);
          }
        })
        .catch((err) => {
          console.log(err);
          this.isDisabled = "0000";
        });
    },
    pause() {
      this.$refs.countDown.pause();
    },
    reset() {
      this.$refs.countDown.reset();
    },
    finish() {
      this.timeStatus = "0001";
      this.reset();
    },
    //注册按钮点击
    submit() {
      if (this.form.phone == "") {
        Toast("手机号不能为空");
        return false;
      }
      if (isPoneAvailable(this.form.phone)) {
        Toast("手机号格式有误");
        return false;
      }
      if (this.form.password == "") {
        Toast("密码不能为空");
        return false;
      }
      if (this.form.password.length < 8 || this.form.password.length > 16) {
        Toast("密码长度为8-16位");
        return false;
      }

      let regp = /^(?=.*[a-zA-Z]+)(?=.*[0-9]+)[a-zA-Z0-9]+$/;

      if (!regp.test(this.form.password)) {
        Toast("密码需包含字母及数字 长度8~16位");
        return false;
      }

      if (this.form.verifyCode == "") {
        Toast("验证码不能为空");
        return false;
      }
      if(this.selectAgreement == false){
        Toast("请勾选用户服务协议和隐私政策!");
        return false;
      }
      this.loading = true;
      baseUrl("/userBase/v1/webRegister", this.form)
        .then((res) => {
          this.loading = false;
          if (res.data.code == "0000") {//注册成功
            this.officeUid = res.data.officeUid;
            this.redmessage = "现金红包";
            this.getActivityDate();
          }else if(res.data.code == "U0001"){//注册失败但是能获取到机构ID
            this.officeUid = res.data.officeUid;
            this.redmessage = "红包已到账";
            this.getActivityDate();
          }else{//注册失败
            Toast(res.data.msg);
          }
        })
        .catch((err) => {
          this.loading = false;
          console.log(err);
          // 跳转到下载页面
          this.handDlownload();
        });
    },
    getActivityDate(){
      baseUrl("/active/v1/getOfficeActiveDetail", {officeCode:this.officeUid,activeCode:this.$route.query.activeCode})
        .then((res) => {
          if(res.data.code == "0000") {
            if(res.data.rewardAmt != "" && res.data.rewardAmt != null){//判断金额是否为空
              this.rewardAmt = res.data.rewardAmt;
              this.isShow = true;
              this.isShowone = true;
              setTimeout(()=>{
                  this.isShowone = false;
                  this.isShowtwo = true;
              },1000)
            }else{
              // 跳转到下载页面
              this.handDlownload();
            }
          }else{
            Toast(res.data.msg);
            // 跳转到下载页面
            this.handDlownload();
          }
        })
        .catch((err) => {
          this.loading = false;
          console.log(err);
          // 跳转到下载页面
          this.handDlownload();
        });
    }
  },
};
</script>
<style scoped>
div /deep/ .van-cell {
  border:0;
  border-bottom: 1px solid #EBEBEB;
  padding:15px 7px
}
div /deep/ .van-count-down {
  line-height: inherit;
  color: #FF1A00;
}
div /deep/ .van-field__value {
  padding-left: 15px;
}
</style>
<style lang="scss" scoped>
.container {
  box-sizing: border-box;
  position: relative;
  width: 100%;
  margin: 0 auto;
  max-width: 640px;
  height: 100vh;
  background: url("../../assets/img/jft_red_bg.png") no-repeat center;
  background-size: 100% 100%;
  overflow: hidden;
}
.top_img{
    margin: 30px auto 0;
    width: 91%;
}
.top_img img{
    width: 100%;
}
.inputGrpup {
  padding: 0 12px;
  box-sizing: border-box;
  position: absolute;
  top: 50%;
  width: 100%;
}
.bgWhite {
  background: #fff;
  padding: 5px 20px 20px;
  border-radius: 15px;
}
[class*=van-hairline]::after,.van-cell::after{
  content: none;
}
.title{
  font-size: 28px;
  font-weight: bold;
  padding-left: 20px;
  padding-top: 20px;
}
.see {
  transform: translateY(3px);
}
.code {
  color: #FF1A00;
  display: flex;
}
.info {
  font-size: 12px;
  margin-top: 15px;
  display: flex;
  justify-content: center;
  line-height: 14px;
}
.info_img img{
    width: 14px;
    height: 14px;
    padding-right: 5px;
}
.agreement {
  color: #FF1A00;
}
.codeGroup {
  width: 80px;
  display: flex;
  justify-content: space-between;
}
.subCondeGrpup {
  display: flex;
  justify-content: center;
  width: 100%;
}
.sub {
  display: flex;
}
.codeTxt {
  cursor: pointer;
}
.van-button--default{
  border:1px solid #FF1A00;
  border-radius: 44px;
}
.bottom-button{
  margin-top: 30px;
}
.lister {
  margin-bottom: 5px;
}
.phone {
  background: url("../../assets/img/phone_red.png") no-repeat left center;
  background-size: 16px 16px;
}
.psw {
  background: url("../../assets/img/pass_red.png") no-repeat left center;
  background-size: 16px 16px;
}
.code2 {
  background: url("../../assets/img/yzm_red.png") no-repeat left center;
  background-size: 16px 16px;
}
.red_cont{
  position: absolute;
  width: 350px;
  height: 562px;
  z-index: 10;
  left: 50%;
  margin-left: -175px;
  top: 50%;
  margin-top: -281px;
}
.red_cont img{
  width: 100%;
}
.red_but{
  position: absolute;
  width: 95px;
  left: 50%;
  margin-left: -48px;
  top: 50%;
  margin-top: -90px;
  animation: myfirst 0.3s infinite;
  -webkit-animation: myfirst 0.3s infinite; /* Safari 与 Chrome */
  animation-direction:alternate;/*轮流反向播放动画。*/
  animation-timing-function: ease-in-out; /*动画的速度曲线*/
}
@keyframes myfirst
{
    from {
		transform:rotateY(180deg);
		-webkit-transform:rotateY(180deg);
	}
    to {
		transform:rotateY(360deg);
		-webkit-transform:rotateY(360deg);
	}
}
.red_but2{
  background: url("../../assets/img/red_but2.png") no-repeat;
  width: 160px;
  height: 44px;
  background-size: 100% 100%;
  position: absolute;
  left: 50%;
  margin-left: -74px;
  bottom: 32%;
  text-align: center;
  line-height: 44px;
  font-size: 17px;
  color: #E42B28;
}
.red_con_number{
  color: #E42B28;
  font-size: 30px;
  position: absolute;
  text-align: center;
  left: 0;
  top: 28%;
  width: 100%;
  margin-left: 5px;
  box-sizing: border-box;
  animation: changes 0.5s;
}
@keyframes changes{
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
}
.red_con_number h1{
  font-weight: normal;
}
.red_con_number p{
  line-height: 30px;
  margin-top: 6px;
  font-size: 24px;
}
.red_back{
  width: 100%;
  height: 100%;
  background: #000;
  z-index: 9;
  opacity: 0.8;
  top: 0;
  left: 0;
  position: absolute;
}
@media screen and ( max-width:320px ) {//iphone5
    .info_img img{
        width: 12px;
        height: 12px;
        padding-right: 2px;
    }
}
@media screen and ( min-width:420px ) and (min-height:720px){//iphone 12promax
    .top_img{
        margin-top: 50px;
    }
}
@media screen and ( max-width:400px) and (min-height:650px) and (max-height:680px){//iphone 12
    .top_img{
        margin-top: 50px;
    }
}
@media screen and ( max-width:400px) and (min-height:800px){//安卓
    .top_img{
        margin-top: 50px;
    }
}
</style>